import { productsData } from '@/app/products/[slug]/products'

/**
 * The HRMS page renders this object and nothing else — every string on the page
 * comes from products.ts, so the copy cannot drift from the source of truth and
 * an edit there shows up on the page immediately.
 *
 * Section headings are either verbatim fragments of `description` /
 * `longDescription` or neutral structural labels ("Overview", "What's
 * included"). No claim about the product is written anywhere in this folder.
 *
 * Two things on the page now sit outside this object: the h1 appends the
 * acronym and the audience to `title` (see hrms-hero.tsx), and the FAQ section
 * reads ../faqs.ts. Both restate claims made elsewhere in the repo; neither
 * introduces a new one.
 */
export const HRMS = productsData.hrms

/** Ordered employee lifecycle: Recruitment → … → Analytics, as authored. */
export const HRMS_MODULES = HRMS.modules

export type HrmsFeature = (typeof HRMS.features)[number]
export type HrmsBenefit = (typeof HRMS.benefits)[number]
export type HrmsModule = (typeof HRMS.modules)[number]
export type HrmsStat = (typeof HRMS.stats)[number]
